export default {
  root: {
    borderRight: [1, 'solid', '#eee'],
  },
};
